/* eslint-disable sonarjs/alt-text */

import { useState } from 'react';

import { cn } from '@/ui/utils/classnames';

interface ImageProps {
  src: string;
  className?: string;
}

const Image = ({ src, className }: ImageProps) => {
  const [loading, setLoading] = useState(true);

  return (
    <div
      className={cn(
        'relative aspect-square w-full overflow-hidden bg-black',
        className,
      )}
    >
      <div
        className={cn(
          'absolute inset-0 flex h-full w-full items-center justify-center bg-white transition-opacity duration-500 theme-dark:bg-black',
          loading ? 'opacity-100' : 'opacity-0',
        )}
      />

      <img
        className="size-full object-cover"
        src={src}
        onLoad={() => setLoading(false)}
      />
    </div>
  );
};

export default Image;
